import { render, staticRenderFns } from "./AiCreditPurchaseRequests.vue?vue&type=template&id=77f01e00&scoped=true"
import script from "./AiCreditPurchaseRequests.vue?vue&type=script&lang=js"
export * from "./AiCreditPurchaseRequests.vue?vue&type=script&lang=js"
import style0 from "./AiCreditPurchaseRequests.vue?vue&type=style&index=0&id=77f01e00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f01e00",
  null
  
)

export default component.exports